import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ButtonUIComponent } from '../../atoms/button/button.component';
import { IconUIComponent } from '../../atoms/icon/icon.component';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { debounceTime, fromEvent, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

// TODO: move in types
interface MoreMenuUIComponentConfig {
  buttonText: string;
  action: () => void;
  disabled?: boolean;
  show?: boolean;
  testId?: string;
}

const RESIZE_DEBOUNCE_MS = 100;

@Component({
  selector: 'fr8bot-ui-more-menu',
  templateUrl: './more-menu.component.html',
  styleUrl: './more-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent, ButtonUIComponent, MatMenuTrigger, MatMenu, TranslatePipe],
})
export class MoreMenuUIComponent {
  config = input<MoreMenuUIComponentConfig[]>([]);

  visibleConfig = computed(() => this.config().filter((cfg) => cfg.show));

  windowWidth = toSignal(
    fromEvent(window, 'resize').pipe(
      debounceTime(RESIZE_DEBOUNCE_MS),
      map(() => window.innerWidth),
      startWith(window.innerWidth),
    ),
    { initialValue: window.innerWidth },
  );
}
